
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/sommardack",
      function () {
        return require("private-next-pages/tyres/sommardack.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/sommardack"])
      });
    }
  